export enum ChatSummaryStatus {
    InProgress = 1,
    Completed,
    Failed
}
